import React, { useEffect, useState } from 'react';
import styles from './PlaceOrder.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from '@material-ui/core';

import { ordersState, setSelectedSavedDropOffAddr, setSelectedSavedPickUpAddr, setShowSavedDropOffAddrModal, setShowSavedPickUpAddrModal } from './placeOrderSlice';
import { applyAddressOrder, reorderAddresses, searchAddresses } from '../saved_address/addressOrdering';
import { AddressForm } from './AddressForm';

import closeIcon from "../../images/place_order/close-icon.png";
import locationIcon from "../../images/place_order/location-address-icon.png";
import { incrementAddressUseCount } from '../address/addressAPI';

export const SavedAddressModal = (props) => {
  const dispatch = useDispatch();
  const orderListState = useSelector(ordersState);

  const [allAddress, setAllAddress] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [isSelectDisabled, setIsSelectDisabled] = useState(true);
  const [query, setQuery] = useState("");
  const [editingAddress, setEditingAddress] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const list = props.type === "PICK_UP" ? orderListState.savedPickUpAddrList : orderListState.savedDropOffAddrList;
    setAllAddress(applyAddressOrder(list, props.type));
  }, [props.type, orderListState.savedPickUpAddrList, orderListState.savedDropOffAddrList]);

  useEffect(() => {
    if (props.type === "PICK_UP") {
      setSelectedAddress(orderListState.selectedSavedPickUpAddr);
      orderListState.selectedSavedPickUpAddr === "" ? setIsSelectDisabled(true) : setIsSelectDisabled(false);
    } else {
      setSelectedAddress(orderListState.selectedSavedDropOffAddr);
      orderListState.selectedSavedDropOffAddr === "" ? setIsSelectDisabled(true) : setIsSelectDisabled(false);
    }
  }, [props.type, orderListState]);

  const closeModal = () => {
    props.type === "PICK_UP"
      ? dispatch(setShowSavedPickUpAddrModal(false))
      : dispatch(setShowSavedDropOffAddrModal(false));
  }

  const onSelectAddress = async () => {
    props.useSavedAddress(selectedAddress);
    closeModal();
    props.type === "PICK_UP"
      ? dispatch(setSelectedSavedPickUpAddr(selectedAddress))
      : dispatch(setSelectedSavedDropOffAddr(selectedAddress));
    await incrementAddressUseCount(selectedAddress.id);
  }

  const onMove = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= allAddress.length) return;
    setAllAddress(reorderAddresses(allAddress, props.type, index, newIndex));
  }

  const onMoveToTop = (index) => {
    if (index === 0) return;
    setAllAddress(reorderAddresses(allAddress, props.type, index, 0));
  }

  const savedAddress = searchAddresses(allAddress, query);
  const isReorderable = query.trim() === "";

  return (
    <>
      <div className={styles.savedAddressModal}>
        <div style={{ display: "flex" }}>
          <p className={styles.tealText} style={{ textAlign: "left", fontWeight: "500" }}>
            {
              showForm
                ? (editingAddress ? "Edit Address" : "Add Address")
                : (props.type === "PICK_UP" ? "Pick-up Address Book" : "Drop-off Address Book")
            }
          </p>
          <img className={styles.icon} style={{ width: 10, marginLeft: "auto", marginRight: 0, marginTop: -5, cursor: "pointer" }} src={closeIcon} alt="close" onClick={closeModal} />
        </div>

        {
          showForm ? (
            <AddressForm
              type={props.type}
              address={editingAddress}
              onCancel={() => { setShowForm(false); setEditingAddress(null); }}
              onSaved={() => { setShowForm(false); setEditingAddress(null); }}
            />
          ) : (
            <>
              {/* Search Box & Add Address */}
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <input
                  id="searchBox"
                  name="searchBox"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Search address"
                  className={styles.searchText}
                />
                <div
                  className={styles.addAddressButton}
                  onClick={() => { setEditingAddress(null); setShowForm(true); }}>
                  <i className="fa fa-plus" style={{ marginRight: 6, color: "white", fontSize: 8 }} />
                  <p className={styles.whiteText} style={{ fontSize: 11 }}>Add</p>
                </div>
              </div>

              {
                isReorderable && allAddress.length > 1 &&
                <p className={styles.greyText} style={{ fontSize: 10, textAlign: "left", marginTop: 2 }}>
                  Use the arrows to change the sequence. Frequently used addresses can be moved to the top.
                </p>
              }

              {/* Saved Addresses */}
              <div className={styles.addressesContainer}>
                {
                  savedAddress.length > 0 && savedAddress.map((addr, index) => {
                    return (
                      <React.Fragment key={addr.id}>
                        <div className={styles.addressRow}>
                          {
                            isReorderable &&
                            <div className={styles.sequenceControls}>
                              <i
                                className="fas fa-angle-double-up"
                                title="Move to top"
                                style={{ color: index === 0 ? "#e0e0e0" : "#1e9299", fontSize: 12, cursor: index === 0 ? "default" : "pointer" }}
                                onClick={() => onMoveToTop(index)}
                              />
                              <i
                                className="fas fa-angle-up"
                                title="Move up"
                                style={{ color: index === 0 ? "#e0e0e0" : "#1e9299", fontSize: 12, cursor: index === 0 ? "default" : "pointer" }}
                                onClick={() => onMove(index, -1)}
                              />
                              <i
                                className="fas fa-angle-down"
                                title="Move down"
                                style={{ color: index === savedAddress.length - 1 ? "#e0e0e0" : "#1e9299", fontSize: 12, cursor: index === savedAddress.length - 1 ? "default" : "pointer" }}
                                onClick={() => onMove(index, 1)}
                              />
                            </div>
                          }
                          <img className={styles.locationIcon} src={locationIcon} alt="target" />
                          <div>
                            <p className={styles.blackText}>{addr.bookmarkName} - {addr.location.address}</p>

                            {/* Saved Pick-up */}
                            {
                              props.type === "PICK_UP" && (addr.location.unitNumber !== "" || addr.pickUpContactNumber !== "" || addr.pickUpPersonName !== "") &&
                              <div style={{ marginTop: 8 }}>
                                <p className={styles.greyText}>{addr.location.unitNumber && addr.location.unitNumber + "\u00a0 • \u00a0"}{addr.pickUpContactNumber}&nbsp; • &nbsp;{addr.pickUpPersonName}</p>
                              </div>
                            }

                            {/* Saved Drop-off */}
                            {
                              props.type === "DROP_OFF" && (addr.location.unitNumber !== "" || addr.recipientPhone !== "" || addr.recipientName !== "") &&
                              <div style={{ marginTop: 8 }}>
                                <p className={styles.greyText}>{addr.location.unitNumber && addr.location.unitNumber + "\u00a0 • \u00a0"}{addr.recipientPhone}&nbsp; • &nbsp;{addr.recipientName}</p>
                              </div>
                            }
                          </div>
                          <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
                            <i
                              className="fa fa-pencil"
                              title="Edit address"
                              style={{ color: "#227c97", fontSize: 12, paddingInline: 8, cursor: "pointer" }}
                              onClick={() => { setEditingAddress(addr); setShowForm(true); }}
                            />
                            <Radio
                              checked={selectedAddress.id === addr.id ? true : false}
                              onChange={() => { setSelectedAddress(addr); setIsSelectDisabled(false); }}
                              size="small"
                              style={{ paddingBlock: 0, color: "#1e9299" }}
                            />
                          </div>
                        </div>
                        <div className={styles.horizontalDivider} />
                      </React.Fragment>
                    )
                  })
                }
                {
                  savedAddress.length === 0 &&
                  <p className={styles.greyText} style={{ marginTop: 20 }}>No saved addresses found.</p>
                }
              </div>

              {/* Select Button */}
              <div className={styles.modalButtonContainer}>
                {
                  isSelectDisabled
                    ? <div className={styles.modalButton} style={{ backgroundImage: "none", backgroundColor: "#e0e0e0", boxShadow: "none" }}>
                      <p className={styles.whiteText} style={{ fontSize: 13 }}>Select</p>
                    </div>
                    : <div className={styles.modalButton} onClick={onSelectAddress}>
                      <p className={styles.whiteText} style={{ fontSize: 13 }}>Select</p>
                    </div>
                }
              </div>
            </>
          )
        }
      </div>
      <div className={styles.overlay} onClick={closeModal}></div>
    </>
  )
}
